import React from 'react';
import { useSelector } from 'react-redux';
import { UserType } from '../../enums';
import HansePayLoader from '../../components/HansePayLoader';
import IndividualVerificationPending from './IndividualVerificationPending';
import CompanyKycVerification from './CompanyKycVerification';

function VerificationPending() {
  const { user, gettingUser } = useSelector((state) => state.user);

  if (gettingUser) {
    return <HansePayLoader variant='inline' minHeight='60vh' />;
  }

  if (user?.userType === UserType.Company) {
    return <CompanyKycVerification />;
  }

  return <IndividualVerificationPending />;
}

export default VerificationPending;
